/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-truncate.vue?vue&type=template&id=024700b2&scoped=true"
import script from "./j-truncate.vue?vue&type=script&lang=js"
export * from "./j-truncate.vue?vue&type=script&lang=js"
import style0 from "./j-truncate.vue?vue&type=style&index=0&id=024700b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024700b2",
  null
  
)

export default component.exports